import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const PopularTreatments = () => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const treatments = [
    {
      title: t('popularTreatments.treatment1'),
      price: 190,
      image: "/assets/Container.webp",
      bg: "#007B83",
    },
    {
      title: t('popularTreatments.treatment2'),
      price: 3000,
      image: "/assets/Container2.webp",
      bg: "#1C99DE",
    },
    {
      title: t('popularTreatments.treatment3'),
      price: 500,
      image: "/assets/Container3.webp",
      bg: "#007B83",
    },
    {
      title: t('popularTreatments.treatment4'),
      price: 3500,
      image: "/assets/Container5.webp",
      bg: "#1C99DE",
    },
  ];

  const headerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.95 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <section ref={ref} className="bg-[#EAF8F9] py-16 md:py-24">
      <div className="container-custom">
        <motion.div
          className="space-y-4 mb-10"
          variants={headerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <div className="bg-white px-2 rounded-full w-fit">
            <span className="text-xs sm:text-sm text-[#5A5A59]">{t('popularTreatments.badge')}</span>
          </div>
          <p className="text-[44px] md:text-[56px] leading-tight font-semibold text-[#0C1B1F]">
            {t('popularTreatments.heading')}
          </p>
          <p className="text-[#000929] max-w-[540px] text-sm sm:text-base md:text-lg">
            {t('popularTreatments.description')}
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {treatments.map((treatment) => (
            <motion.article
              key={treatment.title}
              className="bg-white rounded-3xl overflow-hidden shadow-md border border-[#E5E7EB]"
              style={{ backgroundColor: treatment.bg }}
              variants={cardVariants}
              whileHover={{ scale: 1.03, transition: { duration: 0.3 } }}
            >
              <div className=" w-full overflow-hidden">
                <img
                  src={treatment.image}
                  alt={treatment.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-5 text-white rounded-t-none rounded-b-3xl flex items-center justify-between">
                <div>
                  <h3 className="text-lg sm:text-xl md:text-2xl font-bold">{treatment.title}</h3>
                  <p className="text-white/90 text-xs sm:text-sm md:text-base">
                    {t('popularTreatments.startingFrom')}{" "}
                    <span className="font-semibold text-[#FCD34D] text-sm sm:text-base md:text-lg lg:text-xl">
                      €{treatment.price}
                    </span>
                  </p>
                </div>
                <button
                  aria-label="See treatment"
                  className="h-10 w-10 flex items-center justify-center rounded-full bg-white text-[#0D7780] hover:bg-white/90 transition"
                >
                  <img src="/assets/blackArrow.svg" alt="arrow right" />
                </button>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PopularTreatments;
